import React, { useState } from 'react';
import axios from 'axios';
import { Container, Card, Form, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaUser, FaEnvelope, FaPhone, FaLock, FaUserTie } from 'react-icons/fa';
import vyaparlogo from '../Images/vyaparlogo.png';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';



const Signup = () => {
  const [form, setForm] = useState({ name: '', email: '', mobile: '', password: '', role: '' });
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' }); // Clear error on input change
  };

const validate = () => {
  const newErrors = {};
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]{10}$/;

  if (!form.name.trim()) {
    newErrors.name = 'Name is required';
    alert('Please enter your name.');
  } else if (!form.email.trim()) {
    newErrors.email = 'Email is required';
    alert('Please enter your email.');
  } else if (!emailRegex.test(form.email)) {
    newErrors.email = 'Invalid email format';
    alert('Please enter a valid email address.');
  } else if (!form.mobile.trim()) {
    newErrors.mobile = 'Mobile number is required';
    alert('Please enter your mobile number.');
  } else if (!phoneRegex.test(form.mobile)) {
    newErrors.mobile = 'Mobile must be 10 digits';
    alert('Mobile number must be exactly 10 digits.');
  } else if (!form.password.trim()) {
    newErrors.password = 'Password is required';
    alert('Please enter a password.');
  } else if (form.password.length < 6) {
    newErrors.password = 'Password must be at least 6 characters';
    alert('Password must be at least 6 characters.');
  } else if (!form.role) {
    newErrors.role = 'Please select a role';
    alert('Please select your role.');
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


const handleSubmit = async () => {
  if (!validate()) return;

  try {
    const res = await axios.post('https://vyaparapi.emedha.in/api/auth/signup', form);
    alert(res.data.message || 'Signup successful');

console.log('Signup Response:', res.data);

    // Optionally: store token and user info in local/session storage
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
   navigate('/login');
  } catch (err) {
    if (err.response) {
      if (err.response.status === 409) {
        alert('Email already registered. Please login or use a different email.');
      } else if (err.response.status === 500) {
        alert('Server error. Please try again later.');
      } else {
        alert(err.response.data.message || 'Signup failed. Please try again.');
      }
    } else {
      alert('Network error. Please check your connection.');
    }
  }
};


  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{
           minHeight: '100vh', // full viewport height
    padding: '20px',     // spacing for small screens
    background: 'linear-gradient(135deg, #ddd9d9, #ffffff)',
    overflow: 'auto',    // allow scroll if card exceeds viewport
      }}
    >
      <motion.div
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, type: 'spring' }}
        style={{ width: '100%', maxWidth: '450px' }}
      >
        <Card
          style={{
            borderRadius: '20px',
            padding: '20px',
            backdropFilter: 'blur(15px)',
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.2), 0 0 0 0.5px rgba(255, 255, 255, 0.3)',
          }}
        >
          <Card.Body>
            <div className="text-center mb-4">
   
              <h4 className="mt-1" style={{ color: '#952929', fontWeight: '600' }}>
                Vyapar Bidding Portal
              </h4>
              <p style={{ fontSize: '14px', color: '#333' }}>Create your account</p>
            </div>

            <Form>
              <Form.Group className="mb-3">
                <Form.Label><FaUser className="me-2" />Name</Form.Label>
                <Form.Control
                  name="name"
                  placeholder="name"
                  value={form.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                   style={{
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: errors.name ? '#dc3545' : undefined, // red border
      boxShadow: errors.name ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : undefined // subtle red glow
    }}
                />

              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label><FaEnvelope className="me-2" />Email</Form.Label>
                <Form.Control
                  name="email"
                  placeholder="email"
                  value={form.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                   style={{
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: errors.name ? '#dc3545' : undefined, // red border
      boxShadow: errors.name ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : undefined // subtle red glow
    }}
                />
             
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label><FaPhone className="me-2" />Mobile</Form.Label>
                <Form.Control
                  name="mobile"
                  placeholder="mobile number"
                  value={form.mobile}
                  onChange={handleChange}
                  isInvalid={!!errors.mobile}
                  style={{
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: errors.name ? '#dc3545' : undefined, // red border
      boxShadow: errors.name ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : undefined // subtle red glow
    }}
                />

              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label><FaLock className="me-2" />Password</Form.Label>
                <Form.Control
                  name="password"
                  type="password"
                  placeholder="password"
                  value={form.password}
                  onChange={handleChange}
                  isInvalid={!!errors.password}
           style={{
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: errors.name ? '#dc3545' : undefined, // red border
      boxShadow: errors.name ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : undefined // subtle red glow
    }}
                />
             
              </Form.Group>

<Form.Group className="mb-4">
  <Form.Label><FaUserTie className="me-2" />Role</Form.Label>
  <Form.Select
    name="role"
    value={form.role}
    onChange={handleChange}
    isInvalid={!!errors.role}
    style={{
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: errors.role ? '#dc3545' : undefined,
      boxShadow: errors.role ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : undefined
    }}
  >
    <option value="">Select Role</option>
    <option value="buyer">Buyer</option>
    <option value="seller">Seller</option>
  </Form.Select>
</Form.Group>

              <Button
                className="w-100"
                onClick={handleSubmit}
                style={{
                  backgroundColor: '#952929',
                  borderColor: '#952929',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  borderRadius: '8px',
                  boxShadow: '0 6px 15px rgba(149, 41, 41, 0.4)',
                }}
              >
                Signup
              </Button>
            </Form>
           
<div className="text-center mt-3">
  <span style={{ color: '#333', fontSize: '14px' }}>
    Already have an account?{' '}
    <Link to="/login" style={{ color: '#952929', fontWeight: '600', textDecoration: 'none' }}>
      Login here
    </Link>
  </span>
</div>

          </Card.Body>
        </Card>
      </motion.div>
    </Container>
  );
};

export default Signup;
